import React, { useEffect, useRef, useState } from "react";

const PageBanner = ({ src, alt, height = "320px", overlay = true }) => {
  const [loaded, setLoaded] = useState(false);
  const [inView, setInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className="w-full overflow-hidden relative"
      style={{
        height,
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(20px)",
        transition: "opacity 0.7s ease-out, transform 0.7s ease-out",
      }}
    >
      {!loaded && (
        <div
          className="absolute inset-0 animate-pulse"
          style={{ background: "var(--card-bg)" }}
        />
      )}
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover transition-all duration-700 ${loaded ? "opacity-100 scale-100" : "opacity-0 scale-105"}`}
        style={{ filter: loaded ? "none" : "blur(10px)" }}
        onLoad={() => setLoaded(true)}
        loading="lazy"
      />
      {overlay && (
        <div
          className="absolute inset-0"
          style={{
            background: "linear-gradient(to bottom, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.35) 100%)",
          }}
        />
      )}
    </div>
  );
};

export default PageBanner;
